import { useTranslation } from 'react-i18next';

const useFeaturedResources = () => {
  const { t } = useTranslation();

  const featuredResources = [
    {
      backgroundColor: 'white',
      postTitle: t('organisms_featuredResources_card1_postTitle'),
      resource: t('organisms_featuredResources_card1_resource'),
      excerpt: t('organisms_featuredResources_card1_excerpt'),
      url: t('organisms_featuredResources_card1_href'),
    },
    {
      backgroundColor: 'white',
      postTitle: t('organisms_featuredResources_card2_postTitle'),
      resource: t('organisms_featuredResources_card2_resource'),
      excerpt: t('organisms_featuredResources_card2_excerpt'),
      url: t('organisms_featuredResources_card2_href'),
    },
    {
      backgroundColor: 'white',
      postTitle: t('organisms_featuredResources_card3_postTitle'),
      resource: t('organisms_featuredResources_card3_resource'),
      excerpt: t('organisms_featuredResources_card3_excerpt'),
      url: t('organisms_featuredResources_card3_href'),
    },
    {
      backgroundColor: 'white',
      postTitle: t('organisms_featuredResources_card4_postTitle'),
      resource: t('organisms_featuredResources_card4_resource'),
      excerpt: t('organisms_featuredResources_card4_excerpt'),
      url: t('organisms_featuredResources_card4_href'),
    },
    {
      backgroundColor: 'white',
      postTitle: t('organisms_featuredResources_card5_postTitle'),
      resource: t('organisms_featuredResources_card5_resource'),
      excerpt: t('organisms_featuredResources_card5_excerpt'),
      url: t('organisms_featuredResources_card5_href'),
    },
    {
      backgroundColor: 'white',
      postTitle: t('organisms_featuredResources_card6_postTitle'),
      resource: t('organisms_featuredResources_card6_resource'),
      excerpt: t('organisms_featuredResources_card6_excerpt'),
      url: t('organisms_featuredResources_card6_href'),
    },
  ];
    
  const data = {
    featuredResources,
  };

  return data;
};

export default useFeaturedResources;
